(() => {
  const debounce = (fn, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  };

  const getGap = wrapper => parseInt(getComputedStyle(wrapper)?.gap) || 0;

  const getCumulativeHeight = (sections, index) => {
    let totalHeight = 0;
    for (let i = 0; i < index; i++) {
      totalHeight += sections[i].scrollHeight;
    }
    return totalHeight;
  };

  const equalizeHeights = sections => {
    let maxHeight = 0;

    sections.forEach(item => {
      item.style.height = 'auto'; // Reset the height before recalculating
      maxHeight = Math.max(maxHeight, item.scrollHeight);
    });

    sections.forEach(item => item.style.height = `${maxHeight}px`);
  }

  const getOffset = (el, container) => container ? container.offsetTop + el.offsetTop : el.offsetTop;

  document.querySelectorAll('.scrolling_features').forEach((feature) => {
    const sections = feature.querySelectorAll('.scrolling_features_section');
    const wrapper = feature.querySelector('.scrolling_features_wrapper');
    const bgContainer = feature.closest('.background_container');
    const tabContainer = feature.closest('.tab_container');
    const getHeaderHeight = () => feature.querySelector('.main_text_header')?.scrollHeight || 0;

    const isSticky = () => {
      sections.forEach((el, index) => {
        const prevEl = sections[index - 1] || null;
        if (!prevEl) return;

        const elRect = el.getBoundingClientRect();
        const topOffset = parseInt(getComputedStyle(el).top, 10) || 0; // get top position calculated from CSS
        const paddingBottom = parseInt(getComputedStyle(el).paddingBottom, 10) || 0; // get paddingBottom from CSS
        const offset = paddingBottom * 2; // extra offset for start title animation

        // check if slide became sticky at the top of screen with extra offset
        const isNextSticky = elRect.top <= (topOffset + offset);

        // if next slide became sticky, set previous element is-sticky
        prevEl?.classList.toggle('is-sticky', isNextSticky);
      });
    };

    sections.forEach((el, index) => {
      const scrollTitle = el.querySelector('.top-title');

      scrollTitle?.addEventListener('click', () => window.scrollTo({
        top: (getOffset(feature, bgContainer || tabContainer) + getHeaderHeight()) - getGap(wrapper) + getCumulativeHeight(sections, index),
        behavior: 'smooth'
      }));
    });

    const initFeature = () => {
      isSticky();
      equalizeHeights(sections);// Call the function on window load and resize to ensure the height is recalculated
    }

    // Вызываем при загрузке и изменении размеров окна
    window.addEventListener('scroll', isSticky, { passive: true });
    window.addEventListener('resize', debounce(initFeature, 100), { passive: true });
    document.addEventListener("DOMContentLoaded", initFeature);
    document.addEventListener('readystatechange', e => (e.target.readyState === 'complete') && initFeature());
  });
})();
